module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M15.972 32c-.51 0-1.021-.243-1.41-.632l-5.398-5.446H2.013c-1.103 0-2.014-.796-2.014-1.898V2.09C-.001.989.91 0 2.013 0h27.916c1.101 0 1.974.989 1.974 2.09v21.934c0 1.103-.873 1.898-1.974 1.898h-7.151l-5.398 5.446c-.391.391-.899.632-1.41.632z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/comment-1.js
// module id = 1081
// module chunks = 14